import { Component } from '@angular/core';

@Component({
  selector: 'app-distributor-detail',
  imports: [],
  templateUrl: './distributor-detail.component.html',
  styleUrl: './distributor-detail.component.scss'
})
export class DistributorDetailComponent {

}
